var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-clouds") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-clouds",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0372626,18.7499265 C20.7769052,18.7499265 23,16.5274194 23,13.7871891 C23,11.0463712 20.7769052,8.82386409 18.0372626,8.82386409 C17.6517616,8.82386409 17.2774261,8.87205171 16.9171942,8.95549857 C16.2267009,6.66717419 14.1040949,5 11.5912867,5 C8.51785667,5 6.02737933,7.49106499 6.02737933,10.564495 C6.02737933,10.6779122 6.03678179,10.7889788 6.04383364,10.9012207 C5.7088709,10.810722 5.35804151,10.7578332 4.99545904,10.7578332 C2.78823089,10.7578332 1,12.5472394 1,14.7538799 C1,16.9605203 2.78823089,18.7499265 4.99545904,18.7499265 L18.0372626,18.7499265 Z",
    fill: "#44484C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClouds);
export default __webpack_public_path__ + "static/media/ico-clouds.892ff4cba006e4c2e3a595fe2f77590c.svg";
export { ForwardRef as ReactComponent };